import gql from 'graphql-tag';
import { orderBy, uniqBy } from 'lodash';
import React, { useContext } from 'react';
import { useQuery } from 'react-apollo-hooks';
import { NotebookContext } from '../../../context/NotebookContext';
import SubjectsList from './SubjectsList';

interface SubjectWithTrackers {
  name: string;
  id: string;
  slug: string;
  trackers: {
    name: string;
    active: boolean;
    groups: {
      id: string;
    }[];
  }[];
}

const SUBJECTS_WITH_TRACKERS_QUERY = gql`
  query SubjectWithTrackers($input: SubjectsQueryInput!) {
    subjects(input: $input) {
      name
      id
      slug
      trackers {
        name
        active
        groups {
          id
        }
      }
    }
  }
`;

const UngroupedSubjects = () => {
  const { notebook } = useContext(NotebookContext);
  const { data, loading } = useQuery(SUBJECTS_WITH_TRACKERS_QUERY, {
    variables: {
      input: {
        notebookId: notebook.id
      }
    }
  });
  if (loading) return <div />;
  const subjects = data.subjects || [];

  const subjectsWithUngroupedTrackers = subjects.reduce(
    (acc: SubjectWithTrackers[], cur: SubjectWithTrackers) => {
      const hasUngroupedTrackers = cur.trackers
        .filter(tracker => tracker.active)
        .filter(tracker => tracker.groups.length === 0);

      if (hasUngroupedTrackers.length > 0) {
        acc.push(cur);
      }

      return acc;
    },
    []
  );

  const allUngrouped = uniqBy(
    [...notebook.ungroupedSubjects, ...subjectsWithUngroupedTrackers],
    subject => subject.id
  );
  const alphaUngroupedSubjects = orderBy(allUngrouped, subject => subject.name);

  if (alphaUngroupedSubjects.length === 0) return <div />;

  return (
    <div data-testid="ungrouped-subjects">
      <SubjectsList subjects={alphaUngroupedSubjects} />
    </div>
  );
};

export default UngroupedSubjects;
